<template>
  <div class="search">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <!-- <el-form-item label="题目名称:">
        <el-input v-model="formInline.name" placeholder="题目名称"></el-input>
      </el-form-item>
      <el-form-item label="发布老师:">
        <el-input v-model="formInline.teacher" placeholder="发布老师"></el-input>
      </el-form-item> -->
      <el-form-item label="完成状态:">
        <el-select v-model="formInline.region" placeholder="完成状态" @change="gosearch">
          <el-option label="所有" :value="0"></el-option>
          <el-option label="已完成" :value="1"></el-option>
          <el-option label="未完成" :value="2"></el-option>
           <el-option label="已批改" :value="3"></el-option>
          <el-option label="未批改" :value="4"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="类型:">
        <el-select v-model="formInline.cate" placeholder="类型" @change="gosearch">
          <el-option label="所有" :value="0"></el-option>
          <el-option label="铸造" :value="1"></el-option>
          <el-option label="卡环" :value="2"></el-option>
          <el-option label="素描" :value="3"></el-option>
        </el-select>
    </el-form-item>
      <!-- <el-form-item label="批改:">
        <el-select v-model="formInline.Correction" placeholder="批改" @change="gosearch">
          <el-option label="所有" :value="0"></el-option>
          <el-option label="已批改" :value="1"></el-option>
          <el-option label="未批改" :value="2"></el-option>
        </el-select>
      </el-form-item> -->
       <!-- <el-form-item label="活动时间">

      <el-date-picker type="date" placeholder="选择日期" v-model="formInline.date1" style="width: 100%;"></el-date-picker>

  
  </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="gosearch">查询</el-button>
      </el-form-item> -->
    </el-form>

  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      formInline: {
        teacher: '',
        name: '',
        user: '',
        region: 0,
        cate: 0,
        Correction: '',
        date1:''
      },
    };
  },
  computed: {

  },
  created() {

  },
  methods: {
    gosearch() {
        console.log("ff")
      this.$emit('searchhandle', this.formInline)
    },
    

  },
};
</script>

<style  lang="less">
</style>



// WEBPACK FOOTER //
// src/components/assessment/search.vue